<div class="d-flex">
  <div class="json-editor-wrapper">
    <div class="p-inputgroup">
      <textarea
        [rows]="rowCount"
        [ngClass]="{ 'no-wrap-editor': element.lookupTo === 'Workflow' }"
        pTextarea
        [ngModel]="schema ? jsonSchema : jsonString"
        (ngModelChange)="schema ? (jsonSchema = $event) : (jsonString = $event)"
        disabled
      ></textarea>
      <p-button
        type="button"
        [ngClass]="{ contentActive: value && value?.length !== 0 }"
        pRipple
        icon="pi pi-pencil"
        styleClass="p-button-warn"
        class="icon-color icon-edit"
        title="Editor"
        (onClick)="toggleEditor($event)"
      />
    </div>
  </div>
  <p-dialog
    styleClass="{'json-editor-popup': schema}"
    [(visible)]="showEditor"
    (onHide)="closeDialog($event)"
    [modal]="true"
    [draggable]="true"
    [resizable]="true"
    [baseZIndex]="2500"
    [style]="{ width: '80vw', height: '90vh' }"
    appendTo="body"
    (onShow)="onShow($event)"
    (onResizeEnd)="onResizeEnd($event)"
  >
    <ng-template pTemplate="header">
      <p class="header mb-0" *ngIf="editorOptions.language === 'json'">{{ 'JSON_EDITOR' | translate }}</p>
      <p class="header mb-0" *ngIf="editorOptions.language === 'xml'">{{ 'XML_EDITOR' | translate }}</p>
      <p class="header mb-0" *ngIf="editorOptions.language === 'text/plain'">
        {{ currenttablename }}-{{ (editJson ? 'EDIT_QUERY' : 'ADD_QUERY') | translate }}
      </p>
    </ng-template>
    <div class="editorContainer row">
      <div class="col-md-6 h-100p" [ngClass]="schema ? 'col-md-6' : 'col-md-12'">
        <div class="jsonheader" *ngIf="editorOptions.language === 'xml' || editorOptions.language === 'json'">
          <i class="fa fa-code" *ngIf="editorOptions.language === 'xml'"></i>
          <span *ngIf="editorOptions.language === 'json'">{{ object }}</span>
          <span *ngIf="editorOptions.language === 'json' || editorOptions.language === 'xml'"
            >{{ editorOptions.language | uppercase }} Data</span
          >
          <ng-template *ngIf="editorOptions.language === 'json' || editorOptions.language === 'xml'">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="validateData('source')"
              showDelay="100"
              hideDelay="100"
              pTooltip="Validate"
              tooltipPosition="bottom"
            >
              <i class="fa fa-check-double"></i>
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="formatJson()"
              showDelay="100"
              hideDelay="100"
              pTooltip="Format"
              tooltipPosition="bottom"
            >
              <i class="fa fa-indent"></i>
            </button>
          </ng-template>
        </div>
        <ngx-monaco-editor [options]="editorOptions" class="json-editor" [(ngModel)]="value" style="height: 100%">
        </ngx-monaco-editor>
      </div>
      <div class="col-md-6 h-100p" *ngIf="schema">
        <div class="jsonheader">
          <i class="fa fa-code-branch"></i>
          {{ editorOptions.language | uppercase }} Schema
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="validateData('destination')"
            showDelay="100"
            hideDelay="100"
            pTooltip="Validate"
            tooltipPosition="bottom"
          >
            <i class="fa fa-check-double"></i>
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="formatJsonSchema()"
            *ngIf="schema"
            showDelay="100"
            hideDelay="100"
            pTooltip="Format"
            tooltipPosition="bottom"
          >
            <i class="fa fa-indent"></i>
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="getSchema()"
            *ngIf="schema"
            showDelay="100"
            hideDelay="100"
            pTooltip="Generate Schema"
            tooltipPosition="bottom"
          >
            <i class="fa fa-circle-nodes"></i>
          </button>
        </div>
        <ngx-monaco-editor [options]="viewerOptions" class="json-editor" [(ngModel)]="jsonSchema" style="height: 100%">
        </ngx-monaco-editor>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button
        type="button"
        class="btn btn-primary cancel-btn"
        [ngClass]="{ 'read-only-editor': formFieldDisable }"
        (click)="closeDialog()"
      >
        {{ 'CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        *ngIf="element.lookupTo !== 'Workflow' && !formFieldDisable"
        (click)="saveJson()"
      >
        {{ 'SAVE_AND_CLOSE' | translate }}
      </button>
    </ng-template>
  </p-dialog>
</div>
